import type { FacetSelectedPayload } from '@awazevr/mfe-common.contexts.tms'
import { TmsContextType } from '@awazevr/mfe-common.contexts.tms'
import {
  DataLayerEventType,
  DataLayerFactory,
} from '@awazevr/mfe-common.contexts.tms'

import { dataLayerErrorHandler } from '@/utils/dataLayerErrorHandler'

interface FireFacetSelectedEventProps {
  clickedFeature: FacetSelectedPayload['feature']
  tms: TmsContextType
}

export const fireFacetSelectedEvent = ({
  clickedFeature,
  tms,
}: FireFacetSelectedEventProps): void => {
  new DataLayerFactory().getEvent(DataLayerEventType.FacetSelected).update(
    tms,
    {
      feature: clickedFeature,
    },
    dataLayerErrorHandler,
  )
}
